import React from 'react';
const tomos = [{
  color: '🟢',
  title: 'Tomo 1 — U10/U12',
  desc: '25 sesiones · Fundamentos y psicomotricidad'
}, {
  color: '🟡',
  title: 'Tomo 2 — U13/U15',
  desc: '25 sesiones · Técnica y sistemas básicos'
}, {
  color: '🟠',
  title: 'Tomo 3 — U17/U19',
  desc: '25 sesiones · Sistema 5-1 y especialización'
}, {
  color: '🔴',
  title: 'Tomo 4 — Prep. Física',
  desc: 'Potencia de salto · Fuerza sin gimnasio · Prevención'
}, {
  color: '🟣',
  title: 'Tomo 5 — 101 Drills Pro',
  desc: '101 ejercicios por categoría, nivel y posición'
}, {
  color: '⭐',
  title: 'Tomo 6 — Gestión',
  desc: 'Comunicación con padres · Psicología · Planificación'
}];
const features = ['Planificación anual lista', 'Sistema Abrir y Entrenar', 'Fichas de evaluación por jugador', 'Variantes por nivel', 'Sesiones con objetivo y cierre', 'Material original EDULABS'];
export function WhatYouGet() {
  return <section className="w-full bg-[#0A0A0F] py-14 px-4" data-id="element-260">
      <div className="max-w-3xl mx-auto" data-id="element-261">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-2" data-id="element-262">
          Los 6 Tomos <span className="text-[#FF6B00]" data-id="element-263">Completos</span>
        </h2>
        <p className="text-[#B0B0C0] text-center text-sm mb-8" data-id="element-264">
          150 sesiones · Por nivel y categoría · Evaluación incluida
        </p>

        {/* Tomos list */}
        <div className="bg-[#16161F] border border-[#FF6B0033] rounded-2xl divide-y divide-[#FF6B0033] mb-6" data-id="element-265">
          {tomos.map(tomo => <div key={tomo.title} className="flex items-center gap-3 px-5 py-4" data-id="element-266">
              <span className="text-xl flex-shrink-0" data-id="element-267">{tomo.color}</span>
              <div className="flex-1 min-w-0" data-id="element-268">
                <h3 className="font-bold text-white text-sm" data-id="element-269">{tomo.title}</h3>
                <p className="text-[#B0B0C0] text-xs mt-0.5" data-id="element-270">{tomo.desc}</p>
              </div>
            </div>)}
        </div>

        {/* Features */}
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2" data-id="element-271">
          {features.map(f => <span key={f} className="text-white text-xs font-medium flex items-center gap-1.5" data-id="element-272">
              <span className="text-[#FF6B00]" data-id="element-273">✅</span> {f}
            </span>)}
        </div>
      </div>
    </section>;
}